import $ from 'jquery'
import jqueryUjsInit from 'jquery-ujs'
import ReactOnRails from 'react-on-rails'
import { lazy } from 'react'

import { Notification } from '@lacedltd/laced-components'
import Hint from '../components/Hint'
import Badge from '../components/atoms/Badge'
import Tabs from '../components/atoms/Tabs'
import AddressListInput from '../components/addresses/AddressListInput'
import StripeVerificationBanner from '../components/stripe/StripeVerificationBanner'
import NoResultsGrid from '../components/ProductListing/NoResultsGrid'
import NewPaymentForm from '../components/NewPaymentForm'
import SiteSettings from '../components/essential/SiteSettings'
import CookiePreferencePopUp from '../components/essential/CookiePreferencePopUp'
import AddressForm from '../components/addresses/AddressForm'
import NoResults from '../components/shared/NoResults'
import Search from '../components/AlgoliaSearch'
import TopNav from '../components/TopNav'
import CancelOrder from '../components/account/CancelOrder'

import translationStore from '../reducers/translations'
import growthbookStore from '../reducers/growthbook'
import GlobalStyles from '../src/globalStyles'
import { captureUtm } from '../helpers/utmCapture'

window.$ = $

// Fire first-touch UTM capture on every page load. The helper internally
// no-ops when there's nothing to capture or the visitor was already tagged.
captureUtm()
// loads scripts for handling data-method and data-confirm on elements
// https://github.com/rails/jquery-ujs
jqueryUjsInit(window.$)

ReactOnRails.registerStore({
  translationStore,
  growthbookStore
})

ReactOnRails.register(
  /** @type {any} */ ({
    SiteSettings,
    CookiePreferencePopUp,
    Footer: lazy(() => import('../components/essential/Footer')),
    BlogSubscribe: lazy(() => import('../components/essential/BlogSubscribe')),
    Hint,
    AddressListInput,
    StripeVerificationBanner,
    NewPaymentForm,
    AddressForm,
    Badge,
    NoResultsGrid,
    Notification,
    Tabs,
    Search,
    CancelOrder,
    TopNav,
    GlobalStyles,
    NoResults
  })
)
